import { Paper, Table, TableBody, TableRow, TableCell } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import ThankYouCheck from "../assets/Check.svg";
import ThankYouFailed from "../assets/ThankYouFailed.svg";
import ThankYouPending from "../assets/ThankYouPending.svg";
import ThankYouProcessing from "../assets/ThankYouProcessing.svg";

interface Transaction {
    loanAccountNo: string;
    invoiceNo: string;
    amount: string;
    quickPay: string;
    paymentDate: string;
    receiptNo: string;
    authCode: string;
    paymentStatus: string;
}


const TransactionReceiptFail: React.FC<{ transaction: Transaction | null }> = ({ transaction }) => {
    const getStatusImage = () => {
        switch (transaction?.paymentStatus) {
            case 'Success':
                return { image: ThankYouCheck, text: 'Payment Successful' };
            case 'Fail':
                return { image: ThankYouFailed, text: 'Payment Failed' };
            case 'Pending':
                return { image: ThankYouPending, text: 'Payment Pending' };
            case 'Processing':
                return { image: ThankYouProcessing, text: 'Payment Processing' };;
        }
    };

    const statusInfo = getStatusImage();
    return (
        <>
            {transaction && (
                <Box>
                    <Box sx={{ width: '450px', px: 4, py: 3, borderRadius: '10px' }}>
                        <Paper elevation={3}>
                            <Box sx={{ background: '#0067B2', py: 2, textAlign: 'center' }}>
                                <img src={statusInfo?.image} alt="Logo" />
                                <Box sx={{ fontSize: '1.3rem', fontWeight: '700', color: '#FFF', mt: 1 }}>{statusInfo?.text}</Box>
                            </Box>
                            <Box>
                                <Table className='insTable' aria-label="a dense table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', borderBottom: 'none' }}>Loan Account</TableCell>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', fontWeight: "600", borderBottom: 'none' }}>
                                                {transaction.loanAccountNo}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', borderBottom: 'none' }}>Receipt No</TableCell>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', fontWeight: "600", borderBottom: 'none' }}>
                                                {transaction.invoiceNo}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', borderBottom: 'none' }}>Receipt Number</TableCell>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', fontWeight: "600", borderBottom: 'none' }}>
                                                {transaction.receiptNo}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', borderBottom: 'none' }}>Transaction Date and Time</TableCell>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', fontWeight: "600", borderBottom: 'none' }}>
                                                {transaction.paymentDate}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', borderBottom: 'none' }}>Total Amount paid</TableCell>
                                            <TableCell sx={{ fontSize: '14px', color: '#00104B', fontWeight: "600", borderBottom: 'none' }}>
                                                {transaction.amount}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Box>
                        </Paper>
                    </Box>
                </Box>
            )}
        </>
    )
}

export default TransactionReceiptFail